import SEO from "@/components/SEO";

const Datenschutz: React.FC = () => {
	return (
		<>
			<SEO
				title="Datenschutzerklärung"
				description="Datenschutzerklärung der WILDFÖRSTER Fahrzeugaufbereitung. Informationen zum Datenschutz und zur Verarbeitung personenbezogener Daten."
				canonical="https://aufbereitung-wuppertal.de/datenschutz"
				schema={{
					"@context": "https://schema.org",
					"@type": "WebPage",
					name: "Datenschutzerklärung - WILDFÖRSTER Fahrzeugaufbereitung",
					description:
						"Datenschutzerklärung der WILDFÖRSTER Fahrzeugaufbereitung",
					url: "https://aufbereitung-wuppertal.de/datenschutz",
				}}
			/>
			<main className="min-h-screen bg-black text-white py-20 pt-32">
				<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
					<h1 className="text-4xl md:text-5xl font-bold mb-8">
						Datenschutz&shy;erklärung
					</h1>

					<div className="space-y-8 text-lg">
						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								1. Datenschutz auf einen Blick
							</h2>

							<h3 className="text-xl font-medium mb-2">Allgemeine Hinweise</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Die folgenden Hinweise geben einen einfachen Überblick darüber,
								was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
								Website besuchen. Personenbezogene Daten sind alle Daten, mit
								denen Sie persönlich identifiziert werden können. Ausführliche
								Informationen zum Thema Datenschutz entnehmen Sie unserer unter
								diesem Text aufgeführten Datenschutzerklärung.
							</p>

							<h3 className="text-xl font-medium mb-2">
								Datenerfassung auf dieser Website
							</h3>
							<h4 className="text-lg font-medium mb-2">
								Wer ist verantwortlich für die Datenerfassung auf dieser
								Website?
							</h4>
							<p className="text-white/80 mb-4 leading-relaxed">
								Die Datenverarbeitung auf dieser Website erfolgt durch den
								Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
								„Hinweis zur Verantwortlichen Stelle" in dieser
								Datenschutzerklärung entnehmen.
							</p>

							<h4 className="text-lg font-medium mb-2">
								Wie erfassen wir Ihre Daten?
							</h4>
							<p className="text-white/80 mb-4 leading-relaxed">
								Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
								mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie
								in ein Kontaktformular eingeben.
							</p>
							<p className="text-white/80 mb-4 leading-relaxed">
								Andere Daten werden automatisch oder nach Ihrer Einwilligung
								beim Besuch der Website durch unsere IT-Systeme erfasst. Das
								sind vor allem technische Daten (z. B. Internetbrowser,
								Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung
								dieser Daten erfolgt automatisch, sobald Sie diese Website
								betreten.
							</p>

							<h4 className="text-lg font-medium mb-2">
								Wofür nutzen wir Ihre Daten?
							</h4>
							<p className="text-white/80 mb-4 leading-relaxed">
								Ein Teil der Daten wird erhoben, um eine fehlerfreie
								Bereitstellung der Website zu gewährleisten. Andere Daten können
								zur Analyse Ihres Nutzerverhaltens verwendet werden.
							</p>

							<h4 className="text-lg font-medium mb-2">
								Welche Rechte haben Sie bezüglich Ihrer Daten?
							</h4>
							<p className="text-white/80 mb-4 leading-relaxed">
								Sie haben jederzeit das Recht, unentgeltlich Auskunft über
								Herkunft, Empfänger und Zweck Ihrer gespeicherten
								personenbezogenen Daten zu erhalten. Sie haben außerdem ein
								Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
								Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
								können Sie diese Einwilligung jederzeit für die Zukunft
								widerrufen.
							</p>
						</section>

						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								2. Hosting
							</h2>
							<h3 className="text-xl font-medium mb-2">Externes Hosting</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Diese Website wird bei einem externen Dienstleister gehostet
								(Hoster). Die personenbezogenen Daten, die auf dieser Website
								erfasst werden, werden auf den Servern des Hosters gespeichert.
								Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen,
								Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten,
								Namen, Websitezugriffe und sonstige Daten, die über eine Website
								generiert werden, handeln.
							</p>
						</section>

						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								3. Allgemeine Hinweise und Pflichtinformationen
							</h2>

							<h3 className="text-xl font-medium mb-2">Datenschutz</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
								Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
								vertraulich und entsprechend den gesetzlichen
								Datenschutzvorschriften sowie dieser Datenschutzerklärung.
							</p>

							<h3 className="text-xl font-medium mb-2">
								Hinweis zur verantwortlichen Stelle
							</h3>
							<div className="bg-white/5 p-4 rounded-lg mb-4">
								<p>
									<strong>Daniel Wildförster</strong>
								</p>
								<p>Große Haken Straße 42</p>
								<p>42283 Wuppertal</p>
								<p>Telefon: 0170 3571907</p>
								<p>E-Mail: daniel.wildfoerster@gmail.com</p>
							</div>

							<h3 className="text-xl font-medium mb-2">Speicherdauer</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Soweit innerhalb dieser Datenschutzerklärung keine speziellere
								Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen
								Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.
								Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine
								Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten
								gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe
								für die Speicherung Ihrer personenbezogenen Daten haben.
							</p>

							<h3 className="text-xl font-medium mb-2">
								Widerruf Ihrer Einwilligung zur Datenverarbeitung
							</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Viele Datenverarbeitungsvorgänge sind nur mit Ihrer
								ausdrücklichen Einwilligung möglich. Sie können eine bereits
								erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit
								der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom
								Widerruf unberührt.
							</p>
						</section>

						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								4. Datenerfassung auf dieser Website
							</h2>

							<h3 className="text-xl font-medium mb-2">Kontaktformular</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
								werden Ihre Angaben aus dem Anfrageformular inklusive der von
								Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
								Anfrage und für den Fall von Anschlussfragen bei uns
								gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung
								weiter.
							</p>

							<h3 className="text-xl font-medium mb-2">
								Anfrage per E-Mail, Telefon oder Telefax
							</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird
								Ihre Anfrage inklusive aller daraus hervorgehenden
								personenbezogenen Daten (Name, Anfrage) zum Zwecke der
								Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.
								Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
							</p>
						</section>

						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								5. Soziale Medien
							</h2>

							<h3 className="text-xl font-medium mb-2">Instagram</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Auf dieser Website sind Funktionen des Dienstes Instagram
								eingebunden. Diese Funktionen werden angeboten durch die Meta
								Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal
								Harbour, Dublin 2, Irland.
							</p>

							<h3 className="text-xl font-medium mb-2">Facebook</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Auf dieser Website sind Elemente des sozialen Netzwerks Facebook
								integriert. Anbieter ist die Meta Platforms Ireland Limited, 4
								Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.
							</p>

							<h3 className="text-xl font-medium mb-2">TikTok</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Auf dieser Website können Funktionen des Dienstes TikTok
								eingebunden sein. Anbieter ist die TikTok Technology Limited, 10
								Earlsfort Terrace, Dublin, D02 T380, Irland.
							</p>
						</section>

						<section>
							<h2 className="text-2xl font-semibold mb-4 text-[#cfc297]">
								6. Plugins und Tools
							</h2>

							<h3 className="text-xl font-medium mb-2">Google Web Fonts</h3>
							<p className="text-white/80 mb-4 leading-relaxed">
								Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten
								so genannte Web Fonts, die von Google bereitgestellt werden.
								Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web
								Fonts in ihren Browsercache, um Texte und Schriftarten korrekt
								anzuzeigen.
							</p>
						</section>

						<div className="pt-8 border-t border-white/10">
							<p className="text-white/50 text-sm">
								Quelle:{" "}
								<a
									href="https://www.e-recht24.de"
									target="_blank"
									rel="noopener noreferrer"
									className="text-[#cfc297] hover:underline"
								>
									https://www.e-recht24.de
								</a>
							</p>
						</div>
					</div>
				</div>
			</main>
		</>
	);
};

export default Datenschutz;
